import { GzPolicyUiSettingsBaseGrid } from './component/GzPolicyUiSettingsBaseGrid';

export { GzPolicyUiSettingsBaseGrid };
